import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {

  @HostListener('paste', ['$event'])
  preventPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData.getData('text/plain');
    if (!this.isNumeric(pastedText)) {
      event.preventDefault();
    }
  }
  private isNumeric(value: string): boolean {
    return /^\d+$/.test(value);
  }
}
